import { render, staticRenderFns } from "./TollRoadsDrives.vue?vue&type=template&id=2f640952&"
import script from "./TollRoadsDrives.vue?vue&type=script&lang=js&"
export * from "./TollRoadsDrives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f640952')) {
      api.createRecord('2f640952', component.options)
    } else {
      api.reload('2f640952', component.options)
    }
    module.hot.accept("./TollRoadsDrives.vue?vue&type=template&id=2f640952&", function () {
      api.rerender('2f640952', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TollRoadsDrives.vue"
export default component.exports